const ACTION_KEY = 'REPORT_EXTENSION_FILTER';

const initialState = () => ({
  loading: false,
  data: [],
  filter: {
    term: '',
    data: []
  }
});

const reducer = (state = initialState(), action) => {
  switch (action.type) {
    case `${ACTION_KEY}_PENDING`: {
      return {
        ...state,
        loading: true
      };
    }
    case `${ACTION_KEY}_REJECTED`: {
      return {
        ...state,
        loading: false
      };
    }
    case `${ACTION_KEY}_FULFILLED`: {
      const newData = action.payload;
      return {
        ...state,
        loading: false,
        data: newData,
        filter: {
          ...state.filter,
          data: newData
        }
      };
    }

    default:
      return state;
  }
};

export default reducer;
